module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Synchronize_16"],"path":[{"$":{"d":"M15,2.47V7H10.52l1.86-1.88A5.24,5.24,0,0,0,2.85,7H1.33A6.73,6.73,0,0,1,13.45,4ZM8,13.25a5.21,5.21,0,0,1-4.38-2.37L5.48,9H1v4.53L2.55,12A6.73,6.73,0,0,0,14.67,9H13.15A5.25,5.25,0,0,1,8,13.25Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Synchronize_16.svg
// module id = C0+e
// module chunks = 1